"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlert = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Alert_1 = require("./Alert");
function useAlert(_a = Object.assign(Object.assign({}, { children: undefined }), { Component: Alert_1.Alert })) {
    var { Component } = _a, props = tslib_1.__rest(_a, ["Component"]);
    const [alert, setAlert] = react_1.useState(props.children ? props.children : undefined);
    return {
        alert: alert ? jsx_runtime_1.jsx(Component, Object.assign({}, props, { children: alert }), void 0) : null,
        setAlert: (alert) => {
            setAlert(alert);
        },
    };
}
exports.useAlert = useAlert;
//# sourceMappingURL=useAlert.js.map